import React from 'react'
import SchoolYearParam from '../school-year-param'
import DateParam from '../date-param'
import StudentParam from '../student-param'
import ExperienceParam from '../experience-param'
import { get } from 'lodash'
import FIELD_TYPES from '../../../constants/report-field-types'
import ReflectionParam from '../reflection-param'
import FacilitatorParam from '../facilitator-param'
import DimensionParam from '../dimension-param'
import TextSearchParam from '../text-search-param'

const fieldComponents = {
    [FIELD_TYPES.SCHOOL_YEAR]: SchoolYearParam,
    [FIELD_TYPES.DATE]: DateParam,
    [FIELD_TYPES.STUDENT_ID]: StudentParam,
    [FIELD_TYPES.EXPERIENCE_ID]: ExperienceParam,
    [FIELD_TYPES.REFLECTION_ID]: ReflectionParam,
    [FIELD_TYPES.FACILITATOR_ID]: FacilitatorParam,
    [FIELD_TYPES.DIMENSION_ID]: DimensionParam,
    [FIELD_TYPES.TEXT_SEARCH]: TextSearchParam
}

const Params = ({
    params = [],
    value = {},
    onChange = () => {}
}) => {
    const renderParameter = (param) => {
        const Component = fieldComponents[param.fieldType]
        if (!Component) {
            return null
        }
        const {
            fieldName,
            label,
            
        } = param

        return (
            <Component
                key={fieldName}
                label={label}
                value={get(value, fieldName)}
                onChange={fieldValue => onChange({ ...value, [fieldName]: fieldValue })}
            />
        )
    }

    return (
        <div>
            {params.map(renderParameter)}
        </div>
    )
}

export default Params